export default __webpack_public_path__ + "static/media/Drakonakis.43f4b786.png";